export default function filterLocations(locations, filters) {
  // Keep a venue if any of its categories is one of the selected filters
  return locations.filter((point) =>
    (point.properties?.categories || []).some((category) =>
      filters.includes(category)
    )
  );
}
